import { useEffect, useState } from 'react';
import { useApiContext } from '@/contexts/apiContext';
import ProgressIndicator from '../progressIndicator';
import JsonViewer from './jsonViewer';

type Props = {
  dataSourceDefId: string;
  dataSourceInstanceId: string;
  dataSourceItemId: string;
  filename: string;
  maxHeight: number;
  showLabel?: boolean;
  eventId?: string;
  dataSourceInstance?: any;
  parentItemName?: string;
  pipelineInstanceId?: string;
};

const JsonDataSourceItemViewer = ({
  dataSourceDefId,
  dataSourceInstanceId,
  dataSourceItemId,
  filename,
  maxHeight,
  showLabel,
  eventId,
  dataSourceInstance,
  parentItemName,
  pipelineInstanceId,
}: Props) => {
  const apiContext = useApiContext();

  const [jsonContent, setJsonContent] = useState<any>();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    const downloadJson = async () => {
      setError(null);
      try {
        setLoading(true);

        const meta = dataSourceInstance?.dataSourceDef?.metadata || {};
        const getFromSourceDirectly =
          meta.hasParentChildItems === true && meta.publishParentItemEvents === false && !parentItemName;

        if (getFromSourceDirectly) {
          const data = await apiContext.getDataSourceItemContentDirectFromSource(
            dataSourceDefId,
            dataSourceInstanceId,
            filename || dataSourceItemId,
            false,
          );
          const decoder = new TextDecoder('utf-8');
          setJsonContent(JSON.parse(decoder.decode(data)));
          return;
        }

        const { content, contentType } = await apiContext.getDataSourceInstanceItem(
          dataSourceDefId,
          dataSourceInstanceId,
          dataSourceItemId,
          false,
          eventId,
          pipelineInstanceId,
        );
        const decoder = new TextDecoder('utf-8');
        const textContent = JSON.parse(decoder.decode(content));
        if (textContent.type && textContent.content) {
          if (textContent.type === 'Base64Encoded') {
            const decodedContent = atob(textContent.content);
            setJsonContent(JSON.parse(decodedContent));
          } else {
            setJsonContent(textContent.content);
          }
        } else {
          setJsonContent(textContent);
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (dataSourceDefId && dataSourceInstanceId && dataSourceItemId) {
      downloadJson();
    }
  }, [dataSourceDefId, dataSourceInstanceId, dataSourceItemId, eventId]);

  if (loading) {
    return <ProgressIndicator />;
  }

  return (
    <JsonViewer json={jsonContent || {}} showLabel={showLabel} label={filename} maxHeight={maxHeight} error={error} />
  );
};

export default JsonDataSourceItemViewer;
